document.addEventListener('DOMContentLoaded', () => {
    function setOpen(details, value) {
        if (!details) return;
        if (typeof details.open === 'boolean' && 'transition' in details) {
            details.open = value;
        } else {
            value ? details.setAttribute('open', '') : details.removeAttribute('open');
        }
    }

    const megaMenuItems = document.querySelectorAll('.menu-item-mega-menu');
    if (!megaMenuItems.length) return;

    megaMenuItems.forEach((megaMenuItem) => {
        // Chaque mega menu a son propre subMenu
        const subMenu = megaMenuItem.querySelector('.details-lvl-1 > .dropdown .dropdown__container .dropdown__nav');
        if (!subMenu) return;

        const firstSubMenu = subMenu.querySelector('li:first-child');

        subMenu.querySelectorAll('li').forEach((li) => {
            const details = li.querySelector('details');

            li.addEventListener('mouseover', (e) => {
                e.stopPropagation();
                li.classList.add('hovered');
                setOpen(details, true);
            });

            li.addEventListener('mouseleave', () => {
                li.classList.remove('hovered');
                setOpen(details, false);
            });
        });

        megaMenuItem.addEventListener('mouseover', () => {
            const hasHovered = subMenu.querySelector('li.hovered');
            if (!hasHovered) {
                firstSubMenu.classList.add('hovered');
                setOpen(firstSubMenu.querySelector('details'), true);
            }
        });

        megaMenuItem.addEventListener('mouseleave', () => {
            subMenu.querySelectorAll('li.hovered').forEach(li => {
                li.classList.remove('hovered');
                setOpen(li.querySelector('details'), false);
            });
        });
    });
});